import { render, staticRenderFns } from "./TemplateBill.vue?vue&type=template&id=4678fafb&scoped=true"
import script from "./TemplateBill.vue?vue&type=script&lang=js"
export * from "./TemplateBill.vue?vue&type=script&lang=js"
import style0 from "./TemplateBill.vue?vue&type=style&index=0&id=4678fafb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4678fafb",
  null
  
)

export default component.exports